// @flow

import type { AppType } from "../../types/AppType.js"
import address from "./addresses"
import backoffice from "./backoffice"
import campaignZones from "./campaignZones"
import rating from "./customerFeedback"
import driverRegistry from "./driverRegistry"
import driverWeb from "./driverWeb"
import fleet from "./fleet"
import news from "./news"
import orders from "./orders"
import partnerEconomics from "./partnerEconomics"
import partnerLivemap from "./partnerLivemap"
import partnerOverview from "./partnerOverview"
import product from "./product"
import rc from "./rc"
import role from "./role"
import settlement from "./settlement"
import traffic from "./trafficLiveMap"
import trafficManagement from "./trafficManagement"
import transporter from "./transporter"
import user from "./user"
import vehicle from "./vehicles"
import vouchers from "./vouchers"

export const internalApps = {
  user: (user: AppType),
  role: (role: AppType),
  settlement: (settlement: AppType),
  rc: (rc: AppType),
  fleet: (fleet: AppType),
  product: (product: AppType),
  transporter: (transporter: AppType),
  vehicle: (vehicle: AppType),
  "traffic-management": (trafficManagement: AppType),
  news: (news: AppType),
  "partner-overview": (partnerOverview: AppType),
  "partner-livemap": (partnerLivemap: AppType),
  "partner-economics": (partnerEconomics: AppType),
  vouchers: (vouchers: AppType),
  "driver-registry": (driverRegistry: AppType),
  traffic: (traffic: AppType),
  rating: (rating: AppType),
  "driver-web": (driverWeb: AppType),
  "campaign-zones": (campaignZones: AppType),
  orders: (orders: AppType),
  address: (address: AppType),
  backoffice: (backoffice: AppType)
}

export default internalApps
